import axios from 'axios';
import { IAppConfigType, IAppConfiguration } from '../models/appConfig.model';

let cachedAppConfig: any = null;

export async function fetchAppConfig(config: IAppConfigType = IAppConfigType.PROD, reload: boolean = false): Promise<IAppConfiguration> {
  try {
    if (process.env.REACT_APP_PRODUCTION === 'false') {
      // Retrieve configuration from .env file.
      return {
        portalUrl: process.env.REACT_APP_PORTAL_URL,
        ratUrl: process.env.REACT_APP_RAT_URL,
        deploymentTypeCode: process.env.REACT_APP_DEPLOYMENT_TYPE_CODE,
      } as IAppConfiguration;
    }

    if (!cachedAppConfig || reload) {
      const configUrl = config === IAppConfigType.TEST ? '/assets/app-configuration-test.json' : config === IAppConfigType.PILOT ? '/assets/app-configuration-pilot.json' : '/assets/app-configuration.json';
      const response = await axios.get<IAppConfiguration>(configUrl);
      cachedAppConfig = response.data;
    }
    return cachedAppConfig;
  } catch (error) {
    console.error('Error fetching app configuration:', error);
    throw error;
  }
}
